module.exports = __webpack_public_path__ + "img/safir_logo.c3166cee.png";